"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAYOUT_STYLE_VALUES = void 0;
var LAYOUT_STYLE_VALUES;
(function (LAYOUT_STYLE_VALUES) {
    LAYOUT_STYLE_VALUES[LAYOUT_STYLE_VALUES["SQUARE"] = 1] = "SQUARE";
    LAYOUT_STYLE_VALUES[LAYOUT_STYLE_VALUES["ROUND"] = 2] = "ROUND";
})(LAYOUT_STYLE_VALUES = exports.LAYOUT_STYLE_VALUES || (exports.LAYOUT_STYLE_VALUES = {}));
//# sourceMappingURL=layout-style-values.js.map